import {
  IGameConfigProvider,
  IReelsEngineProvider,
  IStartSlotActionProvider,
  ReelsEngine,
  ReelsSoundModel,
  RegularSpinsSoundModelComponent,
  SpinMode,
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
  CollapseGameConfig,
} from '@cgs/machines';
import { Container, IntervalAction } from '@cgs/wge';
import { SantaFreeFallSpinAction } from './santa-free-fall-spin-action';

export class SantaFreeFallSpinActionComponent implements IStartSlotActionProvider {
  private readonly _container: Container;
  private readonly _reelsEngine: ReelsEngine;
  private readonly _gameConfig: CollapseGameConfig;
  private readonly _reelSoundModel: ReelsSoundModel;

  constructor(container: Container) {
    this._container = container;
    this._reelsEngine =
      this._container.resolve<IReelsEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;

    this._reelSoundModel = this._container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;

    this._gameConfig = this._container.resolve<IGameConfigProvider>(T_IGameConfigProvider)
      .gameConfig as CollapseGameConfig;
  }

  public getStartSlotAction(_spinMode: SpinMode): IntervalAction {
    return new SantaFreeFallSpinAction(
      this._container,
      this._reelsEngine,
      this._gameConfig.regularSpinConfig,
      this._reelSoundModel,
      this._gameConfig.regularSpinCollapsingConfig
    );
  }
}
